import {
  S3_BUCKET_URL,
  BEAR_CATEGORY,
  TWINK_CATEGORY,
  SPORTY_CATEGORY,
  DADDY_CATEGORY,
} from '@/constants';

import { CloseLeanScreen } from './screens/CloseLeanScreen';
import { DrinkOfferScreen } from './screens/DrinkOfferScreen';
import { ElevatorCloseScreen } from './screens/ElevatorCloseScreen';
import { ElevatorSilenceScreen } from './screens/ElevatorSilenceScreen';
import { ScreenEmail } from './screens/Email';
import { EntranceScreen } from './screens/EntranceScreen';
import { EyeContactScreen } from './screens/EyeContactScreen';
import { FinalConsentScreenA } from './screens/FinalConsentSceneA';
import { FinalConsentScreenB } from './screens/FinalConsentScreenB';
import { IntentQuestionScreen } from './screens/IntentQuestionScreen';
import { InviteOverScreen } from './screens/InviteOverScreen';
import { LiftUpScreen } from './screens/LiftUpScreen';
import { ScreenName } from './screens/Name';
import { NeckBreathScreen } from './screens/NeckBreathScreen';
import { ShakingScreen } from './screens/ShakingScreen';
import { StillSureScreen } from './screens/StillSureScreen';
import { UnbuttonShirtScreen } from './screens/UnbuttonShirtScreen';
import { WaistGrabScreen } from './screens/WaistGrabScreen';
import { WelcomeScreen } from './screens/Welcome';
import { LayoutDataType } from './types';

export const layoutSteps = {
  welcome: {
    component: WelcomeScreen,
    images: [],
  },
  name: {
    component: ScreenName,
    images: [`${S3_BUCKET_URL}layout-own-ai-man-roleplay/overlay.png`],
  },
  entrance: {
    component: EntranceScreen,
    images: [`${S3_BUCKET_URL}/layout-own-ai-man-roleplay/entrance-screne.png`],
  },
  eye_contact: {
    component: EyeContactScreen,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/eye-contact-scene.png`,
    ],
  },
  drink_offer: {
    component: DrinkOfferScreen,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/drink-offer-scene.png`,
    ],
  },
  intent_question: {
    component: IntentQuestionScreen,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/intent-question-scene.png`,
    ],
  },
  close_lean: {
    component: CloseLeanScreen,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/close-lean-scene.png`,
    ],
  },
  invite_over: {
    component: InviteOverScreen,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/invite-over-scene.png`,
    ],
  },
  elevator_silence: {
    component: ElevatorSilenceScreen,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/elevator-silence-scene.png`,
    ],
  },
  elevator_close: {
    component: ElevatorCloseScreen,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/elevator-close-scene.png`,
    ],
  },
  unbutton_shirt: {
    component: UnbuttonShirtScreen,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/unbutton-shirt-scene.png`,
    ],
  },
  still_sure: {
    component: StillSureScreen,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/still-sure-scene.png`,
    ],
  },
  waist_grab: {
    component: WaistGrabScreen,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/waist-grab-scene.png`,
    ],
  },
  neck_breath: {
    component: NeckBreathScreen,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/neck-breath-scene.png`,
    ],
  },
  shaking: {
    component: ShakingScreen,
    images: [`${S3_BUCKET_URL}/layout-own-ai-man-roleplay/shaking-scene.png`],
  },
  lift_up: {
    component: LiftUpScreen,
    images: [`${S3_BUCKET_URL}/layout-own-ai-man-roleplay/lift-up-scene.png`],
  },
  final_consent_screen_a: {
    component: FinalConsentScreenA,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/final-consent-scene-a.png`,
    ],
  },
  final_consent_screen_b: {
    component: FinalConsentScreenB,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/final-consent-scene-b.png`,
    ],
  },
  email: {
    component: ScreenEmail,
    images: [`${S3_BUCKET_URL}/layout-own-ai-man-roleplay/email.png`],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  name: '',
  email: '',
};

export const HARDCODED_CATEGORIES = [
  BEAR_CATEGORY,
  TWINK_CATEGORY,
  SPORTY_CATEGORY,
  DADDY_CATEGORY,
];
